import { HttpClient } from '@store/base';
import {
  AddCartGoodsRequest,
  AddCartGoodsResponse,
  BuyDirectGoodsRequest,
  BuyDirectGoodsResponse,
} from '../../model';

export class AddCartGoodsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: AddCartGoodsRequest) {
    return await this.httpClient.request<AddCartGoodsResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/order-service/api/mall/v1/orders/cart`,
      body: req,
    });
  }
}

export class BuyDirectGoodsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: BuyDirectGoodsRequest) {
    return await this.httpClient.request<BuyDirectGoodsResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/order-service/api/mall/v1/orders/direct-buy`,
      body: req,
    });
  }
}
